import { gql } from 'graphql-tag';

export const bulkDeleteSchedules = gql`
  mutation bulkDeleteSchedules(
    $contactListId: String!
    $startDate: String!
    $endDate: String!
  ) {
    bulkDeleteSchedules(
      contactListId: $contactListId
      startDate: $startDate
      endDate: $endDate
    )
  }
`;
